'use client'

import { CommandGroup, CommandItem } from '@/components/v2/ui/command'
import Icon from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'
import { useOrganizationSwitch } from './useOrganizationSwitch'

interface IOrganizationSearchProps {
  onSelect?: () => void
}

export function OrganizationSearch({ onSelect }: IOrganizationSearchProps) {
  const { TENANTS } = useTexts()
  const { tenants, currentOrganization, handleSwitchTenant } = useOrganizationSwitch(onSelect)

  if (tenants.length === 0) {
    return null
  }

  const sortedTenants = [...tenants].sort((a, b) => a.name.localeCompare(b.name))

  return (
    <CommandGroup heading={TENANTS.NAV_USER.SWITCH_TENANT}>
      {sortedTenants.map((tenant) => (
        <CommandItem
          key={tenant.id}
          value={tenant.name}
          onSelect={() => {
            void handleSwitchTenant(tenant.id)
          }}
          className="gap-2 cursor-pointer"
        >
          <div className="flex size-6 items-center justify-center rounded-md border">
            <Icon icon="building" className="size-3.5" />
          </div>
          <span className="flex-1">{tenant.name}</span>
          {currentOrganization.id === tenant.id && <Icon icon="check" className="size-4 text-primary" />}
        </CommandItem>
      ))}
    </CommandGroup>
  )
}
